import LoadingButton from '@/components/Shared/LoadingButton'
import { SaveAndLoadModalAction } from '@/enums/portfolio-optimization.enum'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import React from 'react'

type SaveAndLoadModalProps = {
  isOpen: boolean
  onClose: () => void
  mode: SaveAndLoadModalAction
  currentValue: string
  options?: string[]
  onChange: (value: string) => void
  onConfirm: () => void
  loading: boolean
  saveTitle?: string
  loadTitle?: string
  savePlaceholder?: string
  loadPlaceholder?: string
  saveButtonText?: string
  loadButtonText?: string
}

const SaveAndLoadModal: React.FC<SaveAndLoadModalProps> = ({
  isOpen,
  onClose,
  mode,
  currentValue,
  options,
  onChange,
  onConfirm,
  loading,
  saveTitle = 'Save',
  loadTitle = 'Load',
  savePlaceholder = 'Type to save',
  loadPlaceholder = 'Select to load',
  saveButtonText = 'Save',
  loadButtonText = 'Load',
}: SaveAndLoadModalProps) => {
  const handleClose = (event: any, reason: string) => {
    // Prevent closing the modal when backdrop/outside modal is clicked
    if (reason && reason === 'backdropClick') return
    onClose()
  }
  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth='xs'>
      <DialogTitle>
        {mode === SaveAndLoadModalAction.SAVE ? saveTitle : loadTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {mode === SaveAndLoadModalAction.SAVE ? (
          <TextField
            onChange={(e) =>
              onChange(
                e.target.value && e.target.value.toString().trim().length
                  ? e.target.value
                  : '',
              )
            }
            required
            variant='standard'
            type='text'
            placeholder={savePlaceholder}
            fullWidth
            value={currentValue}
          />
        ) : (
          <FormControl variant='standard' fullWidth>
            <Select
              placeholder={loadPlaceholder}
              labelId='load-screen-constraint-modal-label'
              id='load-screen-constraint-modal'
              value={currentValue}
              onChange={(event) => onChange(event.target.value)}
            >
              {options ? (
                options?.map((constraint, index) => (
                  <MenuItem key={index} value={constraint}>
                    {constraint}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value=''>
                  <em>None</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <LoadingButton
          disabled={!currentValue.length}
          loading={loading}
          onClick={onConfirm}
        >
          {mode === SaveAndLoadModalAction.SAVE
            ? saveButtonText
            : loadButtonText}
        </LoadingButton>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveAndLoadModal
